import type { CSSProperties } from 'react'

/**
 * Parses a simple semicolon-separated CSS declaration block (like theme typography strings)
 * into a React inline style object. Keys are converted to camelCase.
 */
export function cssStringToReactStyle(css: string): CSSProperties {
    const style: Record<string, string> = {}
    for (const declaration of css.split(';')) {
        const trimmed = declaration.trim()
        if (!trimmed) {
            continue
        }
        const colonIndex = trimmed.indexOf(':')
        if (colonIndex === -1) {
            continue
        }
        const key = trimmed.slice(0, colonIndex).trim()
        const value = trimmed.slice(colonIndex + 1).trim()
        if (!key || !value) {
            continue
        }
        const camelKey = key.replace(/-([a-z])/g, (_, letter: string) =>
            letter.toUpperCase()
        )
        style[camelKey] = value
    }
    return style as CSSProperties
}
